import { render } from "./domain.vue?vue&type=template&id=a5ce4e02&scoped=true"
import script from "./domain.vue?vue&type=script&lang=js"
export * from "./domain.vue?vue&type=script&lang=js"

import "./domain.vue?vue&type=style&index=0&id=a5ce4e02&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5ce4e02"]])

export default __exports__